import { useState, type ReactNode } from "react";
import { useTheme } from "./ThemeProvider";
import type { RealtimeStatus } from "../lib/realtime";

export function Topbar({
  crumb,
  title,
  realtime,
  onNew,
}: {
  crumb: string;
  title: string;
  realtime: RealtimeStatus;
  onNew?: () => void;
}) {
  const { theme, setPreference } = useTheme();
  const [q, setQ] = useState("");
  const isLight = theme === "light";

  return (
    <div
      className="glass-panel"
      style={{
        borderBottom: "1px solid var(--border)",
        padding: "14px 26px",
        display: "flex",
        alignItems: "center",
        gap: 16,
        position: "sticky",
        top: 0,
        zIndex: 5,
      }}
    >
      <div>
        <div style={{ fontSize: 11.5, color: "var(--text-3)" }}>{crumb}</div>
        <h1 style={{ fontSize: 19, fontWeight: 700, letterSpacing: "-0.3px", marginTop: 1 }}>{title}</h1>
      </div>

      <label style={{ marginLeft: "auto", display: "flex" }}>
        <span className="sr-only">Search tasks, tickets, people</span>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="⌕ Search tasks, tickets, people…"
          style={{
            background: "var(--bg-2)",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-sm)",
            padding: "8px 13px",
            fontSize: 12.5,
            color: "var(--text-2)",
            minWidth: 230,
            fontFamily: "inherit",
          }}
        />
      </label>

      {/* Realtime connection indicator — colour AND text (never colour-only). */}
      <span
        role="status"
        aria-live="polite"
        title={realtime.connected ? "Live updates connected" : "Reconnecting…"}
        style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11, color: "var(--text-3)", fontWeight: 600 }}
      >
        <span
          aria-hidden="true"
          style={{ width: 7, height: 7, borderRadius: 99, background: realtime.connected ? "var(--teal)" : "var(--brown-light)" }}
        />
        {realtime.connected ? "Live" : "Offline"}
      </span>

      <button
        className="tog"
        onClick={() => setPreference(isLight ? "dark" : "light")}
        aria-pressed={isLight}
        style={{
          background: "var(--bg-2)",
          border: "1px solid var(--border)",
          borderRadius: "var(--radius-sm)",
          padding: "8px 13px",
          fontSize: 12.5,
          color: "var(--text-2)",
          cursor: "pointer",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 7,
          fontFamily: "inherit",
        }}
      >
        <span aria-hidden="true">{isLight ? "☾" : "☀"}</span>
        {isLight ? "Dark" : "Light"}
      </button>

      <button
        className="btn-gold"
        onClick={onNew}
        style={{ padding: "9px 15px", fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" }}
      >
        + New
      </button>
    </div>
  );
}

export function Content({ children }: { children: ReactNode }) {
  return <div style={{ padding: "24px 26px 50px", display: "flex", flexDirection: "column", gap: 22 }}>{children}</div>;
}
